// Toggle del textarea custom_reason en el modal de cancelacion segun
// la razon seleccionada. Replica el `reason === 'Otro' && <textarea>`
// condicional de CommunitySaasCancelContent.tsx.

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["customWrap"];

  toggleCustom(event) {
    const reason = event.params.reason;
    if (reason === "other") {
      this.customWrapTarget.classList.remove("hidden");
    } else {
      this.customWrapTarget.classList.add("hidden");
      this.clearCustom();
    }
  }

  // Ocultar no basta: el textarea sigue en el DOM y se envia igual. Si el
  // usuario escribe una nota y despues cambia de razon, la nota vieja viajaria
  // en el submit.
  clearCustom() {
    const textarea = this.customWrapTarget.querySelector("textarea");
    if (textarea) textarea.value = "";
  }
}
